import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import MBOTWhiteLogo from "../assets/authentication/MBOTWhiteLogo.png";
import MBOTGraduate from "../assets/authentication/MBOTGraduate.png";
import ATPLogo from "../assets/authentication/atpLogo.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { REGISTER, BASE_URL, ATP_LOGIN, ATP_REGISTER } from "../data/Constants";
import { useDispatch } from "react-redux";
import { adminLogin } from "../redux/slices/authSlice";

const AuthLayout = ({ children, rightContainerClassName }) => {
    const { t } = useTranslation();
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    // Use URLSearchParams to extract query parameters
    const searchParams = new URLSearchParams(location.search);
    const email = searchParams.get("email");
    const token = searchParams.get("token");

    useEffect(() => {
        if (email) {
            // Perform the logic to validate and store the token, then redirect
            dispatch(adminLogin({ email, token, navigate, dispatch }));
        }
    }, [token, email, navigate]);

    // Renders the left screen auth content according to URL
    const AuthScreenLeftContent = () => {
        if (location.pathname.startsWith(REGISTER)) {
            // Content for registration screen
            return (
                <>
                    <h5 className="fw-600 fs-30 title">
                        Application Flowchart for <br /> Technologist and Technician
                    </h5>

                    <span className="fs-6">
                        <span className="fw-600">{t("COMMON.AUTH.SCREEN.SUBTITLE.1.TITLE")} - </span>
                        <span className="fw-400 text-gray-100 registration-screen-content">
                            Minimum Bachelor's Degree and <br />
                            above and equivalent qualifications recognized by the Board.
                        </span>
                    </span>
                    <span className="fs-6 registration-screen-subtitle2">
                        <span className="fw-600">{t("COMMON.AUTH.SCREEN.SUBTITLE.2.TITLE")} - </span>
                        <span className="fw-400 text-gray-100 registration-screen-content">
                            Minimum Certificate Level 3 up to <br />
                            Advanced Diploma Level 5 as well as equivalent <br />
                            qualifications recognized by the Board.
                        </span>
                    </span>
                </>
            );
        } else if (location.pathname.includes(ATP_LOGIN)) {
            return (
                <h5 className="fw-bolder fs-30 login-title text-nowrap">
                    Approved Training Provider (ATP) <br />
                    Sign In
                </h5>
            );
        } else if (location.pathname.includes(ATP_REGISTER)) {
            return (
                <h5 className="fw-bolder fs-30 login-title">
                    Approved Training Provider (ATP) <br />
                    Register
                </h5>
            );
        } else if (location.pathname.includes(BASE_URL)) {
            // Content for the login screen
            return (
                <>
                    {/* <h5 className="fw-600 fs-30 login-title">{t("COMMON.WELCOME.TO.MBOT")}</h5> */}
                    {/* <h4
            className="fs-22 fw-500 f-roboto text-white"
            style={{ marginBottom: "137px" }}>
            Your Gateway to professional Recognition and
            <br />
            Innovation in Malaysia
          </h4> */}
                </>
            );
        }
    };

    return (
        <div className="row mt-0 m-0 auth-layout-container">
            {/* Left section for screen-specific content */}
            <section className="col-lg-5 col-12 d-flex justify-content-center align-items-center px-4 flex-column auth-left-screen text-center text-gray-50">
                {/* <img src={MBOTWhiteLogo} alt="MBOT Logo" className="img-fluid header-logo" /> */}
                <AuthScreenLeftContent />
                {/* <img
                    src={location.pathname.includes(ATP_REGISTER) || location.pathname.includes(ATP_LOGIN) ? ATPLogo : MBOTGraduate}
                    alt="MBOT Graduate"
                    className={`img-fluid footer-img ${location.pathname.includes(ATP_REGISTER) || location.pathname.includes(ATP_LOGIN) ? "atp-logo-margin" : ""}`}
                /> */}
                {/* {location.pathname.includes(ATP_LOGIN) ? (
                    <p className="fw-500 fs-16" style={{ marginBottom: "108px" }}>
                        Don’t have an account yet?{" "}
                        <Link className="fw-600 fs-16 text-white cursor-pointer text-decoration-none" to={ATP_REGISTER}>
                            Sign Up
                        </Link>
                    </p>
                ) : location.pathname.includes(ATP_REGISTER) ? (
                    <p className="fw-500 fs-16" style={{ marginBottom: "108px" }}>
                        Already have an Account?{" "}
                        <Link className="fw-600 fs-16 text-white cursor-pointer text-decoration-none" to={ATP_LOGIN}>
                            Sign In
                        </Link>
                    </p>
                ) : (
                    ""
                )} */}
            </section>
            {/* Right section for children components (e.g., login or registration form) */}
            <section className={`col-lg-7 col-12 d-flex flex-column ${rightContainerClassName} align-items-start justify-content-center px-lg-5 px-3`}>
                {/* Renders the children components */}
                {children}
            </section>
        </div>
    );
};

export default AuthLayout;
